import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, NgZone, OnDestroy, OnInit} from '@angular/core';
import {SpinnerService} from "../api/spinner/spinner.service";
import {IonBackdrop, IonSpinner} from "@ionic/angular/standalone";
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonBackdrop,
    IonSpinner
  ]
})
export class SpinnerComponent implements OnInit, OnDestroy {
  private readonly spinnerService = inject(SpinnerService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly zone = inject(NgZone);
  private subscription?: Subscription;

  spinnerVisible = false;

  ngOnInit(): void {
    this.subscription = this.spinnerService.spinnerVisible$.subscribe(visible => {
      this.zone.run(() => {
        this.spinnerVisible = visible;
        this.cdr.markForCheck();
      });
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
